import Reveal from '@/components/base/Reveal';
import { solutionSummary } from '@/mocks/smart-farm-solution';

export default function Summary() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-foreground-950 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20dark%20stylized%20abstract%20agricultural%20technology%20background%20with%20soft%20flowing%20teal%20and%20emerald%20data%20streams%20and%20subtle%20digital%20network%20particles%20over%20a%20deep%20charcoal%20gradient%2C%20minimal%20and%20elegant%20editorial%20illustration%2C%20high%20detail%2C%20cinematic%20lighting&width=1600&height=900&seq=smart-farm-sol-summary-03&orientation=landscape"
          alt="智慧农场方案总结"
          title="智慧农场方案总结"
          className="w-full h-full object-cover object-top opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/90 to-foreground-950"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        <Reveal>
          <div className="text-center max-w-3xl mx-auto">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-background-50/10 border border-background-50/20">
              <span className="w-2 h-2 rounded-full bg-accent-400"></span>
              <span className="text-xs md:text-sm text-background-100 tracking-wide whitespace-nowrap">
                {solutionSummary.eyebrow}
              </span>
            </div>
            <h2 className="mt-4 font-heading font-bold text-background-50 text-2xl md:text-4xl leading-snug">
              {solutionSummary.title}
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-300 leading-relaxed">
              {solutionSummary.desc}
            </p>
          </div>
        </Reveal>

        <Reveal className="mt-12">
          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {solutionSummary.highlights.map((item) => (
              <div
                key={item.label}
                className="flex flex-col items-center gap-3 p-5 rounded-lg bg-background-50/5 border border-background-50/15 transition-all duration-300 hover:bg-background-50/10"
              >
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/15 text-accent-300">
                  <i className={`${item.icon} text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-background-50 whitespace-nowrap">
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal className="mt-12">
          <p className="text-center text-sm md:text-lg text-foreground-200 leading-relaxed max-w-4xl mx-auto font-medium">
            {solutionSummary.closing}
          </p>
        </Reveal>
      </div>
    </section>
  );
}